import {
  Col,
  Divider,
  Row,
  Skeleton,
} from 'antd';
import React from 'react';

const TableSkeleton = ({ rows = 6, dividerMargin = 5 }: { rows?: number, dividerMargin?: number }) => {
  const rowsHtml: JSX.Element[] = [];
  [...Array(rows)].forEach((row, index) => {
    rowsHtml.push(
      <div key={index}>
        <Row gutter={[8, 0]}>
          <Col flex="none">
            <Skeleton.Avatar active size={'large'} shape={'square'} />
          </Col>
          <Col flex="auto">
            <Skeleton.Input active size={'large'} block />
          </Col>
        </Row>
        {index < rows - 1 && <Divider style={{ height: '1px', margin: `${dividerMargin}px 0`}} />}
      </div>
    );
  });

  return (<>
    {rowsHtml}
  </>);
};

export default TableSkeleton;